export default {
  buyer: {
    cat4mro: {
      title: 'CAT4MRO',
    },
    'request-information': {
      title: 'Information Request',
    },
    dashboard: {
      title: 'Dashboard',
      description: 'In this section you can find information about your catalog and activity',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/routes/buyer.js